export enum PalletBinStatusEnum {
    OPEN = 'OPEN',
    CONFIRMED = 'CONFIRMED',
    
}
